export default __webpack_public_path__ + "static/media/math-magicians.0144973b.png";